module.exports = "/assets/data/194c9f8e70845671868497dcb2399758-EC2M.data.json";